import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { inspectReveal, redeemReveal } from "../../services/partnerCalls";
import { Shell, Card, Btn, Note } from "./portalPublic";
import s from "./RevealKey.module.css";

const copyText = (t) => { try { navigator.clipboard.writeText(t); } catch (_) {} };

export default function RevealKey() {
  const [params] = useSearchParams();
  const t = params.get("t") || "";
  const [info, setInfo] = useState(null);
  const [secret, setSecret] = useState(null);
  const [keyId, setKeyId] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!t) { setError("This reveal link is missing its token."); return; }
    inspectReveal(t)
      .then((res) => setInfo(res?.data || res))
      .catch((e) => setError(e?.response?.data?.message || "This reveal link is invalid or has expired."));
  }, [t]);

  const reveal = async () => {
    setBusy(true);
    setError("");
    try {
      const res = await redeemReveal(t);
      const payload = res?.data || res;
      setSecret(payload?.secret);
      setKeyId(payload?.keyId);
    } catch (e) {
      setError(e?.response?.data?.message || "This reveal link is invalid or has already been used.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Shell>
      <Card title="Reveal your API secret key">
        {error && <Note tone="error">{error}</Note>}

        {!secret && info && (
          <>
            <Note>
              You're revealing the {info.env === "sandbox" ? "sandbox" : "live"} secret key for <b>{info.partnerName}</b>. This can be done once, and the link
              expires {info.expiresAt ? new Date(info.expiresAt).toLocaleString() : "soon"}.
            </Note>
            <Btn onClick={reveal} disabled={busy}>{busy ? "Revealing…" : "Reveal my secret key"}</Btn>
          </>
        )}

        {secret && (
          <>
            <Note tone="warn">Store this now — it will not be shown again.</Note>
            {keyId && <div className={s.keyId}>Key id: {keyId}</div>}
            <div className={s.secret}>{secret}</div>
            <Btn onClick={() => { copyText(secret); setCopied(true); }}>{copied ? "Copied" : "Copy secret"}</Btn>
            <div className={s.linkRow}><Link to="/partner-login" className={s.link}>Go to the partner portal →</Link></div>
          </>
        )}

        {!info && !error && <Note>Checking your link…</Note>}
      </Card>
    </Shell>
  );
}

